export default class NotFoundError extends Error {
  public cause: any;

  constructor(cause?: any) {
    super('Address not found');

    Object.setPrototypeOf(this, new.target.prototype);

    this.cause = cause;
  }
}